import Events from '../events'
import EventBus from '../event-bus'
import './user-subscriber'
import './app-subscriber'
import './analytics-subscriber'
import './ecommerce-subscriber'
import './purchase-subscriber'
import './enhanced-flow-subscriber'
import logger from '../../logger'

/**
 * This function will register all subscribers when called, allowing
 * for any circular dependencies to properly resolve.
 */
export default async () => {
  Object.keys(Events).forEach(event => {
    EventBus.$on(Events[event], params => {
      logger.debug(`New event received: ${event}`, params)
    })
  })

  logger.debug('Attaching event listeners')
}
